import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useLightMode } from '@/hooks/useLightMode'

import { Alert, Box } from '@hivewatch/dark'

import { IncidentQueryResult } from '@/graphql/generated/hooks'
import { IncidentSource } from '@/graphql/generated/schemas'

interface DispatchWhiteListAlertIProps {
  incident: IncidentQueryResult['data']['incident']
}

export const DispatchWhiteListAlert = ({
  incident,
}: DispatchWhiteListAlertIProps) => {
  const colorScheme = useLightMode()
  const isQuickReportWhitelistEnabled = useFeatureFlag(
    FeatureFlag.quickReportWhitelist
  )
  const isQuickReportIncident = incident?.source === IncidentSource.QuickReport
  const shouldShowAlert = isQuickReportWhitelistEnabled && isQuickReportIncident

  if (!shouldShowAlert) {
    return null
  }

  return (
    <Box mb='24px' mt='16px'>
      <Alert
        colorScheme={colorScheme}
        description='This QuickReport incident may not be visible to all guards.'
        variant='info'
      />
    </Box>
  )
}
